import Vue from 'vue'
import VueRouter from 'vue-router'
import topNavMenuRoute from "@/router/topNavMenuRoute/index.js"
import signUpMenuRouter from "@/router/signUpMenuRoute/index.js"
import page404 from "@/router/page404/index.js"

import xlooLib from "@/librarys/xlooLib.js"

import WorkerDonateBlood from  '../librarys/WorkerDonateBlood.js'
import store from "../store"

Vue.use(VueRouter);

let routes = []
routes = routes.concat(topNavMenuRoute)
routes = routes.concat(signUpMenuRouter)
routes = routes.concat(page404)

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    WorkerDonateBlood.CreateClean(to, from)
    /*
        if(
            (to.name==='donateBlood' || to.name==='dbChoiceDonationLocation' || to.name==='dbBookingAppointment') &&
            (from.name!=='donateBlood' || from.name!=='dbChoiceDonationLocation' || from.name!=='dbBookingAppointment')
        ){
            store.commit("donateBloodAppointments/set_constructorState")
            next();
            return
        }
        if(
            (from.name==='donateBlood' || from.name==='dbChoiceDonationLocation' || from.name==='dbBookingAppointment') &&
            (to.name!=='donateBlood' || to.name!=='dbChoiceDonationLocation' || to.name!=='dbBookingAppointment')
        ){
            store.commit("donateBloodAppointments/set_destructorState")
            next();
            return
        }

     */
    if(to.name==='donateBlood' && typeof to.query.mobile_code!=='undefined'){
        next({
            name: 'dbBookingAppointment',
            query: {
                mobile_code: to.query.mobile_code,
            },
        })
    }
    if(to.name==='donateBlood' && typeof to.query.temporaryLink!=='undefined'){
        next({
            name: 'dbBookingAppointment',
            query: {
                temporaryLink: to.query.temporaryLink,
                apptIdTemporary: to.query.apptIdTemporary,
                donorId: to.query.donorId,
                lat: to.query.lat,
                lng: to.query.lng,
            },
        })
    }
    if (to.meta.donorAuth && store.getters["auth/authDonor"] === false  && xlooLib.getCookie("auth") !== 'true') {
        next({name: 'loginDonor'});
        return
    }
    if (
        to.name==='dbBookingAppointment'
        && typeof to.query.mobile_code === 'undefined'
        && typeof to.query.temporaryLink === 'undefined'
        && store.getters["donateBloodAppointments/showPageTriggerBookingAppointment"] === false
    ) {
        next({name: 'donateBlood'});
        return
    }
    if (
        to.name==='dbChoiceDonationLocation'
        && typeof to.query.idApp === 'undefined'
        && typeof to.query.elig === 'undefined'
        && store.getters["donateBloodAppointments/showPageTriggerDonationLocation"] === false
    ) {
        next({name: 'donateBlood'});
        return
    }
    next();
})
export default router
